// Libs
import React, { useEffect, useRef } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

// Own Libs
import { ColumnProps, Table } from '@digital/ui';

//Api
import { GraficoTipoPacote } from '@app/api/areaExecutiveSummary';

//Files

//Utils
import { formatCurrencyBr } from '@app/helpers/numbers';

export interface AreaExecutiveSummaryTipoPacoteProps {
  graficoPacote: GraficoTipoPacote;
}

const AreaExecutiveSummaryTipoPacote = ({ graficoPacote }: AreaExecutiveSummaryTipoPacoteProps) => {
  const chartRef = useRef(null);

  if (graficoPacote && graficoPacote.graficoBarra && graficoPacote.graficoBarra.categories) {
    graficoPacote.graficoBarra.categories.push("Total")
  }


  const optionsColumn: Highcharts.Options = {
    chart: {
      type: 'bar',
    },
    title: {
      text: 'Gráfico',
    },
    xAxis: {
      categories: graficoPacote && graficoPacote.graficoBarra ? graficoPacote.graficoBarra.categories : [],
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
    },
    legend: {
      reversed: true,
    },
    plotOptions: {
      series: {
        stacking: 'normal',
      },
    },
    colors: ['#80BDA6', '#E1865C', '#08340D', '#006129'],
    series: graficoPacote && graficoPacote.graficoBarra ? graficoPacote.graficoBarra.series : [],
  };

  const colluns = () => {
    let col: ColumnProps<any>[] = new Array();

    col.push({
      title: `nome`,
      dataIndex: `nome`,
    });

    if (graficoPacote && graficoPacote.collunas && graficoPacote.collunas.length > 0) {
      graficoPacote.collunas.forEach(coluna => {
        col.push({
          title: `${coluna.title}`,
          dataIndex: `${coluna.dataIndex}`,
          render: (text: any, record: any, index: number) => {
            return [<> {formatCurrencyBr(text)}</>];
          },
        });
      });
    }



    return col;
  };

  useEffect(() => { }, []);
  return (
    <>
      {graficoPacote && graficoPacote.graficoBarra ? (
        <>
          <HighchartsReact ref={chartRef} highcharts={Highcharts} options={optionsColumn} />{' '}
        </>
      ) : (
        <> </>
      )}

      <Table
        columns={colluns()}
        dataSource={graficoPacote && graficoPacote.dataSourceResult ? graficoPacote.dataSourceResult : []}
        pagination={false}
      />
    </>
  );
};

export default AreaExecutiveSummaryTipoPacote;
